import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=5db48e2c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=5db48e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db48e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db48e2c')) {
      api.createRecord('5db48e2c', component.options)
    } else {
      api.reload('5db48e2c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=5db48e2c&scoped=true&", function () {
      api.rerender('5db48e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23hFhlu25PbqV/JS/comp/DocBox.vue"
export default component.exports